import { request } from "../../utils/config"

export const GET_TODOS = async (id) => {
  const response = await request({
    url: `TaskComments?sectionID=${id}`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
    },
  })
  return response.data
}

export const GET_TODO = async (id) => {
  const response = await request({
    url: `TaskComments/${id}`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
    },
  })
  return response.data
}
